const ENDPOINTS = {
  ADMIN: {
    AUTH: {
      JWT_ISSUE: '/admin/jwt/signin',
      JWT_AUTH: '/admin/jwt/auth',
      JWT_REISSUE: '/admin/jwt/reissue',
    },
    CUSTOMER_DELIVERY: {
      CREATE_FILE: '/admin/lfs/onetime',
      READ_FILE: '/admin/lfs/onetime',
      UPDATE_FILE: '/admin/lfs/onetime',
      DELETE_FILE: '/admin/lfs/onetime',
      READ_LIST: '/admin/lfs/onetime',
      UPLOAD: {
        INITIATE: '/admin/lfs/onetime/s3/upload/id',
        INSERT: '/admin/lfs/onetime/s3/part/etag/insert',
        URL_ASSIGN: '/admin/lfs/onetime/s3/part/presigned/url',
        STOP: '/admin/lfs/onetime/s3/upload/stop',
        COMPLETE: '/admin/lfs/onetime/s3/report/done',
      },
    },
    EXTERNAL_DELIVERY: {
      CREATE_FILE: '/admin/lfs/share',
      READ_FILE: '/admin/lfs/share',
      UPDATE_FILE: '/admin/lfs/share',
      DELETE_FILE: '/admin/lfs/share',
      READ_LIST: '/admin/lfs/share',
      UPLOAD: {
        INITIATE: '/admin/lfs/share/s3/upload/id',
        INSERT: '/admin/lfs/share/s3/part/etag/insert',
        URL_ASSIGN: '/admin/lfs/share/s3/part/presigned/url',
        STOP: '/admin/lfs/share/s3/upload/stop',
        COMPLETE: '/admin/lfs/share/s3/report/done',
        DELETE: '/admin/lfs/share/s3/upload/delete',
      },
    },
    ACCOUNT_INFO: {
      READ: '/admin/mypage/info',
      UPDATE: '/admin/mypage/info',
    },
    PASSWORD: {
      VALIDATION_CODE_ISSUE: '/admin/password/check',
      VALIDATION_CODE_CHECK: '/admin/password/change',
      CHANGE: '/admin/password/change',
    },
    EMPLOYEE_MANAGEMENT: {
      READ_LIST: '/admin/management/staff',
      DETAIL: '/admin/management/staff',
      UPDATE: '/admin/management/staff',
    },
    OPERATION_HISTORY: {
      CUSTOMER_DELIVERY: {
        READ_LIST: '/admin/history/download/onetime',
        DETAIL: '/admin/history/download/onetime',
      },
      EXTERNAL_DELIVERY: {
        READ_LIST: '/admin/history/download/share',
        DETAIL: '/admin/history/download/share',
      },
    },
    SYSTEM: {
      PREFERENCE: {
        READ: '/admin/config/env',
        UPDATE: '/admin/config/env',
      },
      MANAGEMENT: {
        READ_LIST: '/admin/management/account',
        DETAIL: '/admin/management/account',
        UPDATE: '/admin/management/account',
      },
    },
  },
  STAFF: {
    AUTH: {
      JWT_ISSUE: '/staff/jwt/signin',
      JWT_AUTH: '/staff/jwt/auth',
      JWT_REISSUE: '/staff/jwt/reissue',
    },
    JOIN: {
      JOIN: '/staff/join',
      OK: '/staff/join/ok',
    },
    CUSTOMER_DELIVERY: {
      CREATE_FILE: '/staff/lfs/onetime',
      READ_FILE: '/staff/lfs/onetime',
      UPDATE_FILE: '/staff/lfs/onetime',
      DELETE_FILE: '/staff/lfs/onetime',
      READ_LIST: '/staff/lfs/onetime',
      UPLOAD: {
        INITIATE: '/staff/lfs/onetime/s3/upload/id',
        INSERT: '/staff/lfs/onetime/s3/part/etag/insert',
        URL_ASSIGN: '/staff/lfs/onetime/s3/part/presigned/url',
        STOP: '/staff/lfs/onetime/s3/upload/stop',
        COMPLETE: '/staff/lfs/onetime/s3/report/done',
      },
    },

    ACCOUNT_INFO: {
      READ: '/staff/mypage/info',
      UPDATE: '/staff/mypage/info',
    },
  },
  USER: {
    DOWNLOAD_FILE: {
      CUSTOMER_DELIVERY: {
        FILE_AUTH: '/user/download/onetime',
        DOWNLOAD: '/user/download/onetime',
      },
      EXTERNAL_DELIVERY: {
        DOWNLOAD: '/user/download/share',
      },
    },
  },
};

export default ENDPOINTS;
